export default {
	到: '到',
	登录: '登录',
	第三方登录: '第三方登录',
	点击登录: '点击登录',
	点击注册: '点击注册',
	记住我: '记住我',
	距离完成注册仅剩下最后一步: '距离完成注册，仅剩下最后一步啦!!!',
	没有账号: '没有账号',
	设置密码: '设置密码',
	完成注册: '完成注册',
	'忘记密码?': '忘记密码?',
	修改密码: '修改密码',
	验证码: '验证码',
	已有账号: '已有账号',
	重新发送: '重新发送',
	注册: '注册',
	注册验证码: '注册验证码',
	重置密码: '重置密码',
	重置密码成功: '重置密码成功',
	重置密码成功提示: '请保管好您的新密码，并使用新密码登录',
}
